export const SKIMLINKS_WRAP_HOST = 'go.skimresources.com';
export const TRACKONOMICS_WRAP_HOST = 'clicks.trx-hub.com';
//# sourceMappingURL=constants.js.map